
import React from 'react';
import { Handle, Position } from '@xyflow/react';

interface TriggerNodeProps {
  data: {
    label: string;
    description?: string;
  };
  selected: boolean;
}

export const TriggerNode: React.FC<TriggerNodeProps> = ({ data, selected }) => {
  return (
    <div className={`p-3 rounded-md border-2 ${selected ? 'border-primary' : 'border-border'} bg-card shadow-sm min-w-[180px]`}>
      <div className="flex items-center gap-2 font-medium text-sm mb-1">
        <div className="w-3 h-3 rounded-full bg-green-500"></div>
        {data.label}
      </div>
      {data.description && (
        <p className="text-xs text-muted-foreground">{data.description}</p>
      )}
      
      {/* Only output handle for trigger nodes */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="out"
        className="w-3 h-3 bg-primary border-2 border-background"
      />
    </div>
  );
};
